import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const apiBaseInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith('/api')) {
    return next(req);
  }

  const apiBase = (environment.apiUrl || '').trim();
  if (!apiBase) {
    return next(req);
  }

  const normalizedBase = apiBase.replace(/\/+$/, '');
  const backendPath = req.url.replace(/^\/api/, '');
  const targetUrl = `${normalizedBase}${backendPath}`;

  return next(req.clone({ url: targetUrl }));
};

